module.exports = __webpack_public_path__ + "img/found.6aa213b4.png";